/**
 * List of upcoming Repair Cafe dates.
 * Each entry can be:
 * - A string in YYYY-MM-DD format (e.g., "2026-01-31")
 * - An object with date and canceled status: { date: "2026-01-31", canceled: true }
 * 
 * Add future dates here; the app will show the next one that hasn't passed.
 * If a date is canceled, set canceled: true to display a cancellation message.
 */
export const upcomingDates = [
  // Last Saturday of each month in 2026
  "2026-01-31",
  "2026-02-28",
  "2026-03-28",
  "2026-04-25",
  "2026-05-30",
  "2026-06-27",
  "2026-07-25",
  "2026-08-29",
  "2026-09-26",
  "2026-10-31",
  "2026-11-28",
  "2026-12-26",
];
